import { render, staticRenderFns } from "./ParamGroup.vue?vue&type=template&id=1d37ca46"
import script from "./ParamGroup.vue?vue&type=script&lang=js"
export * from "./ParamGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports